import React, { useState, useEffect } from 'react'
import { QuestionUtils } from '../../utils/siteUtils'
import ConditionPage from './ConditionPage'
import ConditionSvgsV2 from './ConditionSvgsV2'
import PrimaryNavigation from '../condition/Tabs/PrimaryNavigation'
import LabelTags from './LabelTags'
import { pageObject } from '../../constants/pageObject'
import { useScroller } from '../../hooks'

export default ({ prospectDocuments, interiorSeatRows, exteriorDoorCount, addImpressions, ...props }) => {
  const { anyAnswered } = props
  const { shouldShowOfferCreationComponent } = props.experienceState
  const [setHasScrolled, scroll] = useScroller()
  const conditionQuestions = prospectDocuments.documents && prospectDocuments.documents.find(document => document.id.split('/')[0] === 'qc').items.filter(item => item.section === 'Vehicle Condition')
  const title = conditionQuestions && conditionQuestions[0] ? conditionQuestions[0].section : 'n/a'
  // US522106 pick out odor question transform it into a ToggleSelect type button instead of a Boolean for display purposes
  const odorQuestion = prospectDocuments.documents && prospectDocuments.documents.find(document => document.id.split('/')[0] === 'qp').items.find(q => q.questionId === 'qp/65')
  //  const toggleOdor = { ...odorQuestion, label: 'Has noticable odors', questionType: 'ToggleSelect', item: 'qp/65', subsectionCode: 'Odors' }
  const toggleOdor = { ...odorQuestion, label: 'Has noticable odors', questionType: 'ToggleSelect', item: 'Odors', subsectionCode: 'interior', itemHeader: 'Odors', itemDescription: '(maybe from smoking, pets or mold)' }
  if (conditionQuestions) conditionQuestions.push(toggleOdor)
  const itemQuestions = ['Interior' + interiorSeatRows, 'DriverSide' + exteriorDoorCount, 'Rear', 'PassengerSide' + exteriorDoorCount, 'FrontWithGrille', 'GlassLights' + interiorSeatRows]
  const iconQuestions = [
    'ABS',
    'Airbags',
    'Check Engine',
    'Service Engine',
    'Low Coolant',
    'Maintenance',
    'Oil Pressure',
    'Engine',
    'Transmission',
    'Steering',
    'Exhaust',
    'Suspension',
    'Heating/Air Conditioning',
    'Battery/Electrical',
    'Stereo',
    'Odometer',
    'Sunroof/Moonroof',
    'Airbags_mech',
    'Frame/Structural',
    'Tires & Rims',
    'Brakes'
  ]
  const movedQuestions = ['Odors']
  //determine exterior, interior, mechanical tab
  const [tab, setTab] = useState('Exterior')
  const [secondaryTabExterior, setSecondaryTabExterior] = useState('Front')
  const [secondaryTabInterior, setSecondaryTabInterior] = useState('Seats')
  const [svgItems, setSvgItems] = useState([])
  const [svgIcons, setSvgIcons] = useState([])
  const [movedItems, setMovedItems] = useState([])
  const [addMolding, setAddMolding] = useState(true)
  const [pageName, setPageName] = useState()
  const [badgeCnt, setBadgeCnt] = useState({})
  function SetSvgs() {
    switch (tab) {
      case 'Interior':
        setAddMolding(false)
        setSvgItems(['Interior' + interiorSeatRows])
        setSvgIcons(['ABS', 'Airbags', 'Check Engine', 'Service Engine', 'Low Coolant', 'Maintenance', 'Oil Pressure'])
        setMovedItems(['Odors'])
        if (secondaryTabInterior === 'Seats') setSvgItems(['Interior' + interiorSeatRows])
        setPageName('interior')
        break
      case 'Mechanical':
        setAddMolding(false)
        setSvgItems([])
        setMovedItems([])
        setSvgIcons(['Engine', 'Transmission', 'Steering', 'Exhaust', 'Suspension', 'Heating/Air Conditioning', 'Battery/Electrical', 'Stereo', 'Odometer', 'Sunroof/Moonroof', 'Airbags', 'Frame/Structural'])
        setPageName('mechanical')
        break
      default:
        if (secondaryTabExterior === 'Windows') {
          setAddMolding(false)
          setPageName('glass')
        } else {
          setAddMolding(true)
          setPageName('exterior')
        }
        setSvgItems(['DriverSide' + exteriorDoorCount, 'Rear', 'PassengerSide' + exteriorDoorCount, 'GlassLights' + interiorSeatRows, 'FrontWithGrille'])
        setSvgIcons(['Brakes'])
        setMovedItems([])
        break
    }
  }

  useEffect(() => {
    SetSvgs()
    setHasScrolled(true)
    scroll('body', 'top')
  }, [tab, secondaryTabExterior, secondaryTabInterior, addMolding, props.model])

  //Overwrite next button to send all impressions
  const onNextPageSelected = () => {
    const analytics = []

    itemQuestions.reduce((acc, cur) => {
      const svgFound = conditionQuestions.find(question => question.subsectionCode && cur.toLowerCase().includes(question.subsectionCode))
      const svgSubSectionCode = (svgFound || {}).subsectionCode || '' // this lets us get around multiple seats issues
      const svgAnyAnswered = anyAnswered(QuestionUtils.getAssociatedQuestions(conditionQuestions, '', svgSubSectionCode))

      analytics.push({ key: svgSubSectionCode, value: svgAnyAnswered })

      return acc || svgAnyAnswered
    }, false)
    iconQuestions.reduce((acc, cur) => {
      let iconFound
      // custom check for airbags mechanical question for Next button overwrite, since we have all question references on this page, there is Airbags twice, we have to specify
      if (cur === 'Airbags_mech') {
        iconFound = conditionQuestions.find(question => question.subsectionCode && question.subsectionCode === 'MechanicalIssues' && cur.toLowerCase().startsWith(question.item.toLowerCase()))
      } else {
        iconFound = conditionQuestions.find(question => question.subsectionCode && cur.toLowerCase().startsWith(question.item.toLowerCase()))
      }
      const iconSubSectionCode = (iconFound || {}).subsectionCode || '' // this lets us get around multiple seats issues
      const iconAnyAnswered = anyAnswered(QuestionUtils.getAssociatedQuestions(conditionQuestions, cur, iconSubSectionCode))

      analytics.push({ key: cur, value: iconAnyAnswered })

      return acc || iconAnyAnswered
    }, false)
    movedQuestions.reduce((acc, cur) => {
      const questionFound = conditionQuestions.find(question => question.item.toLowerCase().startsWith(movedQuestions[0].toLowerCase()))
      const questionSubSectionCode = (questionFound || {}).subsectionCode || ''
      const questionAnyAnswered = anyAnswered(QuestionUtils.getAssociatedQuestions(conditionQuestions, cur, questionSubSectionCode))

      analytics.push({ key: cur, value: questionAnyAnswered })

      return acc || questionAnyAnswered
    }, false)

    addImpressions && addImpressions(analytics)
    props.updateGlobalState({ cp: pageObject[tab], fireAnalytics: 'continue' })
  }

  const renderConditionPage = () => {
    if (!shouldShowOfferCreationComponent) {
      return (
        <ConditionPage {...{ title, conditionQuestions, svgItems, svgIcons, movedQuestions, movedItems, tab, itemQuestions, iconQuestions, ...props }} onNextClicked={onNextPageSelected} primaryNavigation={true} pageName={pageName}>
          <PrimaryNavigation {...{ secondaryTabExterior, setSecondaryTabExterior, secondaryTabInterior, setSecondaryTabInterior, conditionQuestions, tab, setTab, badgeCnt, setBadgeCnt, addImpressions, ...props }}></PrimaryNavigation>
          <ConditionSvgsV2 width={400} height={320} {...{ svgItems, addMolding, conditionQuestions, setBadgeCnt, secondaryTabExterior, secondaryTabInterior, ...props }}>
            <LabelTags {...{ svgIcons, conditionQuestions, setBadgeCnt, secondaryTabExterior, tab, ...props }} />
          </ConditionSvgsV2>
        </ConditionPage>
      )
    } else {
      return <ConditionPage {...{ title, conditionQuestions, svgItems, svgIcons, movedQuestions, movedItems, tab, itemQuestions, iconQuestions, ...props }} onNextClicked={onNextPageSelected} primaryNavigation={true} pageName={pageName}></ConditionPage>
    }
  }

  return renderConditionPage()
}
